import { useSettings } from './settings';
export const BASE_CATEGORIES = ['entrance', 'interior', 'bathroom', 'office'];
export function useCategories() {
 const { settings } = useSettings();
 return [...new Set([...BASE_CATEGORIES, ...((settings?.categories || []).map(c => c.id))])];
}
